<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <!-- <a @click="getItem(prev)" class="route float-right mb-5"
      >{{ $t("drug.nextDrug") }}<v-icon>mdi-chevron-right</v-icon></a
    > -->
    <v-container fluid>
      <div class="page-title">
        <h2>{{ $t("drugInventory") }} {{ "#" + this.$route.params.id }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          v-if="drug"
          color="primary"
          dark
          small
          class="mr-2"
          :to="{
            name: 'EditDrug',
            params: { id: +drugid },
          }"
        >
          {{ $t("drug.editDrug") }}
        </v-btn>
        <v-btn
          v-if="drug"
          color="primary"
          dark
          small
          class="mr-2"
          @click.stop="dialog = true"
        >
          {{ $t("drug.deleteDrug") }}
        </v-btn>
      </div>
      <v-card elevation="10" class="px-5">
        <v-card-text v-if="del" class="text-center">
          <v-avatar size="135"> </v-avatar>
          <p class="text-h4 font-weight-bold">
            {{ $t("drug.noRecordfound") }}
          </p>
          <p>
            {{ $t("drug.statementDrug") }}
          </p>
          <div class="text-center">
            <v-btn
              rounded
              color="primary"
              width="239"
              height="38"
              :to="{ name: 'DrugRegister' }"
            >
              {{ $t("drug.addDrug") }}
            </v-btn>
          </div>
        </v-card-text>
        <v-card-text v-else>
          <v-tabs v-model="tabs" background-color="transparent" color="primary">
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tabs" class="mt-5">
            <v-tab-item>
              <information></information>
            </v-tab-item>
            <v-tab-item>
              <pack-expiration :dateFormat="format"></pack-expiration>
            </v-tab-item>
            <v-tab-item>
              <pack-order :dateFormat="format"></pack-order>
            </v-tab-item>
            <v-tab-item>
              <pack-reservation :dateFormat="format"></pack-reservation>
            </v-tab-item>
            <v-tab-item>
              <location :dateFormat="format"></location>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("drug.cONFIRM") }}
        </v-card-title>

        <v-card-text>
          {{ $t("drug.sTATEMENT") }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey darken-1" text @click="dialog = false">
            {{ $t("drug.cANCEL") }}
          </v-btn>

          <v-btn color="green darken-1" text v-on:click="deleteItem(+drugid)">
            {{ $t("drug.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import Information from "./druginventory/Information.vue";
import PackExpiration from "./druginventory/PackExpiration.vue";
import PackOrder from "./druginventory/PackOrder.vue";
import Location from "./druginventory/location.vue";
import PackReservation from "./druginventory/PackReservation.vue";
import { getDrugById, deleteDrug } from "@/graphql/Drug.gql";

export default {
  components: {
    breadcrumb: Breadcrumb,
    Information,
    PackExpiration,
    PackOrder,
    Location,
    PackReservation,
  },
  apollo: {
    getDrugById: {
      query: getDrugById,
      update: (data) => data.getDrugById,
      fetchPolicy: "no-cache",
      variables() {
        return {
          id: +this.$route.params.id,
        };
      },
      result({ data }) {
        this.stopLoading();
        this.$store.dispatch("loadDrug", data?.getDrugById);
      },
      error(errors) {
        this.stopLoading();
        console.log("errors", errors);
      },
    },
  },
  data() {
    return {
      dialog: false,
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("drugInventory"),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "DrugList" },
        },
      ],
      tabs: null,
      drugid: null,
      del: false,
      prev: "",
      drug: true,
      items: [
        this.$t("drug.information"),
        this.$t("drug.packExpiration"),
        this.$t("drug.packOrder"),
        this.$t("drug.packReservation"),
        this.$t("drug.packLocation"),
      ],
    };
  },
  async mounted() {
    this.startLoading();
    this.drugid = this.$route.params.id;
  },

  methods: {
    deleteItem(id) {
      this.startLoading();
      this.$apollo
        .mutate({
          mutation: deleteDrug,
          variables: {
            id: parseInt(id),
          },
        })
        .then(async ({ data }) => {
          this.stopLoading();
          console.log(data);
          if (data?.deleteDrug) {
            this.$notify({
              title: "Success!",
              text: "Drug deleted successfully!",
              type: "success",
            });
            this.$router.push({
              name: "DrugList",
            });
          }
        })
        .catch((e) => {
          console.log("arc", e);
          this.stopLoading();
        });
    },
    format(inputDate) {
      if (inputDate !== null) {
        var date = new Date(inputDate);
        if (!isNaN(date.getTime())) {
          console.log("mm", date.getMonth());
          // Months use 0 index.
          return `${date.getDate()}/${
            date.getMonth() + 1
          }/${date.getFullYear()}`;
        }
      } else {
        return inputDate;
      }
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}
.route {
  text-decoration: none !important;
  position: absolute;
  top: 15px;
  right: 10px;
}
/* .tab{
    font-size: 12px;
	letter-spacing: 0.05em;
} */
</style>
